<template>
  <el-dialog title="信用卡还款详情" :visible.sync="dialogTableVisible" width="40%">
    <el-row class="border-bottom">
      <el-col :span="24" class="line-height">
        <el-col :span="4">信用卡持有人：</el-col>
        <el-col :span="19">{{this.tableData.cardholderName}}</el-col>
      </el-col>
      <el-col :span="24" class="line-height">
        <el-col :span="4">开户银行：</el-col>
        <el-col :span="19">{{this.tableData.bankName}}</el-col>
      </el-col>
      <el-col :span="24" class="line-height">
        <el-col :span="4">信用卡号：</el-col>
        <el-col :span="19">{{this.tableData.bankNumber}}</el-col>
      </el-col>
      <el-col :span="24">
        <table class="table" border="1" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th>扣款店铺</th>
              <th>扣款金额</th>
              <th>转换人民币</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{this.tableData.shopName}}</td>
              <td>{{this.tableData.originaltotalCurrencyamount}}</td>
              <td>{{this.tableData.originalTotalCny}}</td>
              <td>{{this.tableData.fundtransferdate}}</td>
            </tr>
          </tbody>
        </table>
      </el-col>
      <el-col :span="24" class="line-height">
        <el-col :span="4">预还款总计金额：</el-col>
        <el-col :span="19">{{this.tableData.originalTotalCny}}CNY</el-col>
      </el-col>
      <el-col :span="24" class="line-height">
        <el-col :span="4">实还款金额：</el-col>
        <el-col :span="19">
          <el-input v-model="this.tableData.repayAmount" :disabled="true" @input="change($event)">
            <template slot="append">CNY</template>
          </el-input>
        </el-col>
      </el-col>
      <el-col :span="24" class="line-height">还款凭证：</el-col>
      <el-col :span="24">
        <el-image
        class="voucher"
          v-for="(item,i) in this.tableData.repayCredentialsList"
          :key="i"
          :src="item.url"
          :preview-src-list="item.repayCredentialsList"
        ></el-image>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false">取 消</el-button>
      <el-button type="primary" @click="DetailedDetermine">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Detailed",
  data() {
    return {
      dialogTableVisible: false,
      tableData: [
        {
          shop: "",
          Cardnumber: "",
          Bank: "",
          time: ""
        }
      ],
    };
  },
  mounted() {},
  created() {},
  methods: {
    init(e) {
      this.dialogTableVisible = true;
      this.tableData = e;
      console.log(this.tableData)
    },
    DetailedDetermine() {
      this.dialogTableVisible = false;
      // this.$parent.
    },
    change(e){
      this.$forceUpdate()
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 13px 20px;
  }
}
.padding {
  padding: 5px 0;
}
.line-height {
  line-height: 35px;
}
.text-align {
  text-align: center;
  line-height: 30px;
}
img {
  width: 100%;
  height: 100%;
}
.voucher{
    width: 100px;
    height: 100px;
    margin-left: 5px;
}
.table{
  width: 100%;
  height: 50px;
  border:solid 1px #c4c6ca;
}
.table th{
  height: 30px;
  text-align: center;
  color: #909399;
  border:solid 1px #c4c6ca;
}
.table td{
  height: 30px;
  text-align: center;
  border:solid 1px #c4c6ca;
}
</style>